import {
  SERVICE_ENDPOINTS,
  CONNECTION_MANAGEMENT_ENDPOINTS,
  KNOWLEDGE_ENGINE_ENDPOINTS,
  MEDIA_PROCESSING_ENDPOINTS,
} from '../constants/endpoints';
import { getStageFromUrl } from './stageUtil';
import type { Region } from '../shared/contexts/RegionContext';

export const getServiceEndpoint = (): string => {
  const stage = getStageFromUrl();
  const endpoint = SERVICE_ENDPOINTS[stage];
  console.log('WinBot service endpoint:', endpoint);
  return endpoint;
};

export const getConnectionManagementEndpoint = (region: Region = 'global'): string => {
  const stage = getStageFromUrl();
  const endpoint = CONNECTION_MANAGEMENT_ENDPOINTS[region][stage];
  console.log('Connection Management endpoint:', endpoint, 'for region:', region);
  return endpoint;
};

// Knowledge Engine is GLOBAL-only; the caller must gate on region === 'global' before using this
// (KE has no China backend). Signed with the same global credentials as Connection Management.
export const getKnowledgeEngineEndpoint = (): string => {
  const stage = getStageFromUrl();
  const endpoint = KNOWLEDGE_ENGINE_ENDPOINTS.global[stage];
  console.log('Knowledge Engine endpoint:', endpoint);
  return endpoint;
};

export const getMediaProcessingEndpoint = (): string => MEDIA_PROCESSING_ENDPOINTS[getStageFromUrl()];
